import {sendFormAsAjax} from './functions';
import * as bootstrap from 'bootstrap';

if (document.querySelector(".contact-details")) {
    // ---------------------------
    // Expandable Order Rows Feature
    // ---------------------------
    window.toggleOrderDetails = function (orderID) {
        let detailsRow = document.getElementById("order-details-" + orderID);
        if (detailsRow && !event.target.closest('.skip-toggle')) {
            detailsRow.style.display = (detailsRow.style.display === "table-row") ? "none" : "table-row";
        }
    };

    // ---------------------------
    // Add and edit Event
    // ---------------------------
    const addEventForm = document.getElementById("addEventForm");

    if (addEventForm) {
        addEventForm.addEventListener("submit", function (event) {
            event.preventDefault();

            let Url = addEventForm.getAttribute("action");
            let method = addEventForm.getAttribute("data-method") || 'post';

            sendFormAsAjax(this, method, Url);
        });
    }

    document.querySelectorAll('.edit-event-btn').forEach(button => {
        button.addEventListener('click', function () {
            const addEventModal = document.getElementById('addLeadModal');
            const eventId = this.getAttribute('data-event-id');
            const addEventForm = document.getElementById("addEventForm");
            let actionUrl = addEventForm.getAttribute("action");
            const addLeadModalLabel = document.getElementById('addLeadModalLabel');
            const addLeadModalEvent = new bootstrap.Modal('#addLeadModal', []);

            if (eventId) {
                if (addLeadModalLabel) {
                    addLeadModalLabel.textContent = 'Edit Event';
                }

                actionUrl = actionUrl.replace('create', eventId);
                addEventForm.setAttribute("action", actionUrl);
                addEventForm.setAttribute("data-method", 'patch');

                axios.get(`/leads/${eventId}`)
                    .then(response => {
                        const data = response.data;
                        if (data) {
                            // Open the modal
                            addLeadModalEvent.show();

                            addEventModal.querySelector('#contact_method').value = data.contact_method || '';
                            addEventModal.querySelector('#date').value = (data.date || '').substring(0, 10);
                            addEventModal.querySelector('#opportunity_change').value = data.opportunity_change || '';
                            addEventModal.querySelector('#opportunity_type').value = data.opportunity_type || '';
                            addEventModal.querySelector('#notes').value = data.notes || '';
                        }
                    })
                    .catch(error => {
                        console.error("❌ Error fetching lead data:", error);
                        alert("⚠️ An unexpected error occurred.");
                    });
            } else {
                if (addLeadModalLabel) {
                    addLeadModalLabel.textContent = 'Add Event';
                }

                actionUrl = actionUrl.replace(/\/\d+$/, '/create');
                addEventForm.setAttribute("action", actionUrl);
                addEventForm.setAttribute("data-method", 'post');

                // Reset form fields
                console.log('reset form');
                addEventForm.querySelector('#contact_method').selectedIndex = 0;
                addEventForm.querySelector('#date').value = new Date().toISOString().substring(0, 10);
                addEventForm.querySelector('#opportunity_change').selectedIndex = 0;
                addEventForm.querySelector('#opportunity_type').selectedIndex = 0;
                addEventForm.querySelector('#notes').value = '';

                addLeadModalEvent.show();
            }
        });
    });
}
